module.exports = __webpack_public_path__ + "static/media/doctor.7acef22a.png";